<template>
  <div v-html="paginationInfo" />
</template>

<script>
import PaginationMixin from './PaginationMixin';

export default {
  name: 'PaginationInfo',

  mixins: [PaginationMixin],

  props: {
    infoTemplate: {
      type: String,
      default: '{from} - {to} of {total}',
    },
  },

  computed: {
    paginationInfo() {
      if (!this.isPaginate) {
        return null;
      }

      return this.infoTemplate
        .replace('{from}', this.pagination.from || 0)
        .replace('{to}', this.pagination.to || 0)
        .replace('{total}', this.pagination.total || 0)
    },
  },
}
</script>
